export enum ForeignSystemType {
  TecRMI = 'tecrmi',
  TecDocGenart = 'genart',
  HBase = 'hbase',
  EMDM = 'emdm',
  HaynesPro = 'haynespro',
  LKQJob = 'lkqjob'
}
